<!--  -->
<template>
  <div class="loading-page">
    <img src="~@/assets/images/loading.gif" class="loading" />
  </div>
</template>

<script>
// 导入的其他文件 例如：import moduleName from 'modulePath';

export default {
  //import所引入的组件注册
  components: {},

  data() {
    return {};
  }
};
</script>
<style lang='less'>
//@import url(); 引入公共css类
.loading-page {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 5%;
  background: #fff;
  #flex-box.row-c-c();
  z-index: 6;
  .loading {
    width: 90px;
    height: 90px;
    margin-left: 250px;
  }
}
</style>